import {
    FETCH_STOCK_WISE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_STOCK_WISE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_STOCK_WISE_DATA_FOR_REPORT_FAILURE_DK,
    FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_REQUEST_DK,
    FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_FAILURE_DK,
    FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_SUCCESS_DK,
    FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_REQUEST_DK,
    FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_FAILURE_DK,
    FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_SUCCESS_DK,
    SET_TAB_NAME_DATA,
    FETCH_STOCK_REPORT_CP_DATA_REQUEST,
    FETCH_STOCK_REPORT_CP_DATA_SUCCESS,
    FETCH_STOCK_REPORT_CP_DATA_FAILURE,
    SET_CP_TAB_NAME_DATA
} from './stockWiseReport.actionType';

export const REPORT_STOCK_DK = 'reportStockDK';

let initialState = {
    loading: false,
    reportProgramStockWiseList: [],
    reportProgramStockWiseFABList: [],
    reportProgramStockWiseACCList: [],
    renderTab: 'Yarn',
    fabricStockStyleWise: [],
    renderTabCP: 'summary',
};

export let reportStockDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STOCK_WISE_DATA_FOR_REPORT_REQUEST_DK:
        case FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_REQUEST_DK:
        case FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_REQUEST_DK:

        //**** Stock Report CP **** //
        case FETCH_STOCK_REPORT_CP_DATA_REQUEST:

            return {
                ...state,
                loading: true
            };

        case FETCH_STOCK_WISE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportProgramStockWiseList: updatePayload
            };
        case FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportProgramStockWiseACCList: updatePayload
            };
        case FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportProgramStockWiseFABList: updatePayload
            };
        //**** Stock Report CP **** //
        case FETCH_STOCK_REPORT_CP_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricStockStyleWise: updatePayload
            };
        case FETCH_STOCK_WISE_DATA_FOR_REPORT_FAILURE_DK:
        case FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_FAILURE_DK:
        case FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_FAILURE_DK:
        case FETCH_STOCK_REPORT_CP_DATA_FAILURE:
            return {
                ...state,
                loading: false
            };
        case SET_TAB_NAME_DATA:
            return {
                ...state,
                loading: false,
                renderTab: payload
            };
        case SET_CP_TAB_NAME_DATA:
            return {
                ...state,
                loading: false,
                renderTabCP: payload
            };
        default:
            return state;
    }
};
